import React from 'react'
import { connect } from 'react-redux'
import { isEmpty } from 'lodash'

const StickyDelivery = ({
  user,
  userDefaultAddress
}) => {
  return (
    <React.Fragment>
      {(
        <div className="sticky-delivery">
          <i className="mdi mdi-map-marker"></i> Enviar a {user.firstName} -
            {!isEmpty(userDefaultAddress) && ` ${userDefaultAddress.calle} 
            ${userDefaultAddress.numeroExterior} 
            ${userDefaultAddress.numeroInterior} 
            ${userDefaultAddress.colonia} 
            ${userDefaultAddress.cp} 
            ${userDefaultAddress.localidad} 
            ${userDefaultAddress.municipio} 
            ${userDefaultAddress.state && userDefaultAddress.state.nomEstado} 
            ${userDefaultAddress.country && userDefaultAddress.country.nameEs}`}
            {isEmpty(userDefaultAddress) && ` Sin dirección de envío preseleccionada.`}
        </div>
      )}
    </React.Fragment>
  )
}

const mapStatetoProps = (state) => {
  return { user: state.Login.user }
}

export default connect(mapStatetoProps, {})(StickyDelivery)
